import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getReportAddresses = (state) => resolveProp('profile.reportAddresses', state);

export default createSelector(getReportAddresses, (addresses) => addresses);
